<div class="w-screen h-screen bg-transparent select-none md:w-full md:h-full">
    <div class="mx-auto w-full md:max-w-[30rem] h-full md:max-h-[30rem] lg:max-h-[43rem] bg-white overflow-hidden">
        <div class="flex items-center justify-between gap-2 px-4 py-3 border-b border-gray-200">
            <p class="font-semibold text-gray-700">{{ label() }}</p>
            <lepi-icon (click)="handleDismiss()" name="mdi:close" class="flex cursor-pointer bg-neutral-800 size-6" />
        </div>
        @if (terms(); as term) {
            <div class="lg:max-w-[30rem] pb-4 md:max-h-[40rem] w-full h-full gap-6 overflow-hidden overflow-y-scroll text-sm break-all">
                <quill-view format="html" [content]="term.content | decodeHtml" />
            </div>
        } @else {
            <p class="p-4 text-sm text-neutral-600">등록된 내용이 없습니다.</p>
        }
    </div>
</div>
